export type Question = {
  id: number;
  form_version_id: number;
  question_type: QuestionType;
  question_text: string;
  question_hint: string;
  question_number: number;
  is_required: boolean;
  answer_type: AnswerType;
  is_comment: boolean;
  is_random: boolean;
  is_comment_required: boolean;
  comment_hint: string;
  response_limits: number;
  multi_restrict_type?: MultiRestrictType | null;
  screen_name?: string;
  button_name?: string;
  form_quest_headers: Header[];
  form_answers: Answer[];
  form_question_rel: Relation[];
  form_end_points: EndPoint[];
};

export type Answer = {
  id: number;
  form_question_id: Question['id'];
  answer_text: string;
  answer_number: number;
  is_answer_comment: boolean;
  is_alert: boolean;
  is_not_random: boolean;
  header_row_id: Header['id'] | null;
  header_col_id: Header['id'] | null;
};

/**
 * Описывает связь одного вопроса с другим и необходимые условия для перехода.
 */
export type Relation = {
  id: number;
  form_question_id: Question['id'];
  form_next_question_id: Question['id'];
  relation_number: number;
  is_default: boolean;
  condition_logical_group: ConditionLogicalGroup | null;
  form_questions_rel_conditions: Condition[];
};

/**
 * Условие перехода с одного вопроса на другой.
 */
export type Condition = {
  id: number;
  condition_statement: ConditionStatement;
  form_questions_rel_id: Relation['id'];
  condition_question_id: Question['id'];
  condition_answer_list: Answer['id'][];
};

/**
 * Заголовок строки или столбца матричного вопроса.
 */
export type Header = {
  header_number: number;
  header_text: string;
  header_type: HeaderType;
  id: number;
  is_alert: boolean | null;
  is_blocked: boolean | null;
  form_question_id: Question['id'];
};

export type EndPoint = {
  id: number;
  form_question_id: number;
  button_name: string;
  end_point_name: string;
  end_point_url?: string;
};

export enum HeaderType {
  ROW = 'ROW',
  COL = 'COL'
}

/**
 * Вводит ограничение: можно выбрать только 1 ответ в строке/столбце матричного вопроса или любое количество.
 */
export enum MultiRestrictType {
  MULTI_ALL = 'MULTI_ALL',
  ONE_IN_COLUMN = 'ONE_IN_COLUMN',
  ONE_IN_ROW = 'ONE_IN_ROW'
}

/**
 * Определяет, в каком виде юзеру отображаются варианты ответов на вопрос.
 */
export enum AnswerType {
  SingleSelect = 'SingleSelect', // Можно выбрать только 1 ответ.
  MultiSelect = 'MultiSelect', // Можно выбрать несколько ответов.
  GraphicSelect = 'GraphicSelect', // Варианты отображаются в виде звезд.
  GraphicSelectNum = 'GraphicSelectNum', // Варианты отображаются в виде звезд c порядковыми номерами.
  Text = 'Text', // Свободный комментарий (обычно просто поле ввода).
  Matrix = 'Matrix' // Матричный вопрос.
}

/**
 * Определяет логику сочетания условий перехода для проверки возможности такого перехода.
 */
export enum ConditionLogicalGroup {
  AND = 'AND',
  OR = 'OR'
}

/**
 * Определяет логику проверки условия перехода.
 * Связано с ответами юзера.
 */
export enum ConditionStatement {
  ANY_EQUAL = 'ANY_EQUAL',
  FULL_MATCHED = 'FULL_MATCHED',
  FULL_PART_MATCHED = 'FULL_PART_MATCHED'
}

/**
 * Определяет, как будет выглядеть конкретный этап прохождения опроса.
 */
export enum QuestionType {
  Question = 'Question', // Вопрос, на который юзер может ответить, используя поля ввода.
  LastPage = 'LastPage' // Финальная страница с благодарностями.
}

/**
 * Статус прохождения опроса для отправки на сервер.
 */
export enum SurveyStatus {
  ENTERED = 'ENTERED', // при открытии опроса или возвращении на страницу с другой вкладки
  IN_PROGRESS = 'IN_PROGRESS', // при каждой отправке ответа на вопрос
  SUCCEEDED = 'SUCCEEDED', // при отправке ответа на последний вопрос
  CLOSE_WIDGET = 'CLOSE_WIDGET' // при переходе на другую вкладку браузера или закрытии страницы
}
